export default __webpack_public_path__ + "static/media/cloud_right.cd8961e8.png";